import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import type { LegacyCronMigrationAnalysis } from '../utils/legacyCronMigration';
import { CronScheduleMigrationNotice } from './CronScheduleMigrationNotice';

interface CronScheduleMigrationConfirmDialogProps {
  open: boolean;
  migration: LegacyCronMigrationAnalysis | null;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export const CronScheduleMigrationConfirmDialog = ({
  open,
  migration,
  onCancel,
  onConfirm,
  isSubmitting = false,
}: CronScheduleMigrationConfirmDialogProps) => {
  if (!migration) return null;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Update legacy schedule format?</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          This schedule was saved with an older cron format. Saving will replace the stored
          expression with the corrected version below. EventBridge fire times may change.
        </Typography>
        <CronScheduleMigrationNotice migration={migration} compact />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Save updated schedule'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
